import { useRef } from "react";
import { useQuery } from "react-query";
import { useLocation } from "react-router-dom";

import { deXuatNhaCungCapApi } from "src/1/apis/de_xuat_nha_cung_cap.api";
import { nguyenVatLieuApi } from "src/1/apis/nguyen_vat_lieu.api";
import { CIconButton } from "src/1/common/components/controls";
import { CTable } from "src/1/common/components/others";
import { history } from "src/App";
import { EditPencil, FlagIcon, TrashFill } from "src/common/assets/icons";
import { CButton, CRating } from "src/common/components/controls";
import { fireDelete } from "src/utils/alert";

import { FormModal } from "../FormModal";
import { ImagesList } from "../ImagesList";

export const FormTable = ({
  formId,
  suppliers = [],
  mode,
  setMode,
  refetch,
}) => {
  //#region Data
  const { pathname } = useLocation();

  const { data: materials_options } = useQuery({
    queryKey: ["danh-sach-nvl"],
    queryFn: () => nguyenVatLieuApi.getAll(),
    select: (response) =>
      response?.data?.data?.map((e) => ({ value: e?.code, label: e?.name })),
  });

  const modalRef = useRef(null);
  //#endregion

  //#region Event
  const onPopupCreateModal = () => modalRef.current?.open();

  const onRemoveSupplier = (supplierId) => async () => {
    const isConfirm = await fireDelete({
      title: "Xóa nhà cung cấp",
      text: "Bạn có chắc chắn muốn xóa nhà cung cấp này không?",
    });
    if (isConfirm) {
      try {
        await deXuatNhaCungCapApi.deleteSupplier(formId, supplierId);
        refetch();
        noti("success", "Đã xóa nhà cung cấp!");
      } catch (error) {
        noti("error", error?.message ?? "Xóa nhà cung cấp không thành công!");
      }
    }
  };

  const onPopupUpdateModal = (supplierI) => () =>
    modalRef.current?.open(supplierI);
  //#endregion

  //#region Render
  const headers = [
    {
      key: "code",
      label: "Mã NCC",
      style: { minWidth: 190 },
    },
    {
      key: "name",
      label: "Tên NCC",
      align: "left",
      style: { minWidth: 320 },
    },
    {
      key: "financial",
      label: "Năng lực tài chính",
      style: { minWidth: 180 },
      cellRender: (value) => <CRating value={value} disabled />,
    },
    {
      key: "reputation",
      label: "Uy tín NCC",
      style: { minWidth: 140 },
      cellRender: (value) => <CRating value={value} disabled />,
    },
    {
      key: "quality",
      label: "Chất lượng",
      style: { minWidth: 140 },
      cellRender: (value) => <CRating value={value} disabled />,
    },
    {
      key: "pricing",
      label: "Giá cả",
      style: { minWidth: 140 },
      cellRender: (value) => <CRating value={value} disabled />,
    },
    {
      key: "materials",
      label: "Danh sách NVL cung cấp",
      align: "left",
      style: { minWidth: 300 },
      cellRender: (value) => (
        <div className="flex flex-row flex-wrap whitespace-pre-wrap gap-x-2 gap-y-1 max-w-[400px]">
          {(value ?? []).map((material, index) => (
            <span key={material.id} className="whitespace-nowrap">
              {material.name}
              {index !== value.length - 1 && ","}
            </span>
          ))}
        </div>
      ),
    },
    {
      key: "files",
      label: "Tài liệu minh chứng",
      style: { minWidth: 185 },
      cellRender: (value, record, index) => <ImagesList list={value} />,
    },
    ...(mode === "supplier"
      ? [
          {
            key: "action",
            label: "",
            pin: "right",
            style: { minWidth: 100, padding: 0 },
            cellRender: (value, record, index) =>
              !record?.is_edit ? (
                <span className="font-semibold text-base text-green-600 whitespace-nowrap px-5">
                  Đã đánh giá
                </span>
              ) : (
                <div className="flex gap-1 flex-row items-center justify-center">
                  <CIconButton
                    disabled={!record?.is_edit}
                    icon={<EditPencil className="!size-5" />}
                    onClick={onPopupUpdateModal(record)}
                  />
                  <CIconButton
                    disabled={!record?.is_edit}
                    color="error"
                    icon={<TrashFill className="!size-5" />}
                    onClick={onRemoveSupplier(record?.id)}
                  />
                </div>
              ),
          },
        ]
      : [{}]),
    ...(mode === "rating"
      ? [
          { key: "status", label: "Trạng thái", style: { minWidth: 140 } },
          {
            key: "rating",
            label: "Đánh giá",
            style: { minWidth: 160 },
            cellRender: (value, record, index) => (
              <CButton
                onClick={() =>
                  history.push(`${pathname}/supplier/${record?.id}`)
                }
                className="btn-fill !bg-[#FFB946]"
                icon={<FlagIcon />}
              >
                Đánh giá
              </CButton>
            ),
          },
        ]
      : []),
  ];
  return (
    <>
      <div className="px-3 mb-4 flex flex-row">
        {mode === "supplier" && (
          <>
            <CButton onClick={onPopupCreateModal}>Thêm nhà cung cấp</CButton>
            <CButton color="danger" onClick={() => setMode("form")}>
              Hủy
            </CButton>
          </>
        )}
        {mode === "form" && (
          <CButton onClick={() => setMode("supplier")}>
            Cập nhật nhà cung cấp
          </CButton>
        )}
      </div>
      <CTable
        rowKey="id"
        headers={headers}
        headerMultiline
        data={suppliers}
        headerTransform="capitalize"
      />

      <FormModal
        ref={modalRef}
        formId={formId}
        materials_options={materials_options}
        refetch={refetch}
      />
    </>
  );
  //#endregion
};
